import React from 'react';
import { Card, Empty } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { Chart } from 'react-google-charts';
import { Button } from '../../../design-system';

const TenureDistributionChart = ({ data = [], onSegmentClick, onExportCSV }) => {
    if (!data || data.length === 0) {
        return (
            <Card title="Tenure Distribution" className="chart-card">
                <Empty description="No data available" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </Card>
        );
    }

    const chartData = [['Tenure', 'Employees']];
    for (const item of data) {
        chartData.push([item.tenureGroup, item.count]);
    }

    const options = {
        legend: { position: 'none' },
        hAxis: {
            title: 'Tenure',
            slantedText: true,
            slantedTextAngle: 30,
        },
        vAxis: {
            title: 'Employees',
            minValue: 0,
            format: '0',
        },
        colors: ['#FED230'],
        chartArea: { width: '80%', height: '65%' },
        backgroundColor: 'transparent',
        bar: { groupWidth: '70%' },
    };

    const chartEvents = onSegmentClick ? [
        {
            eventName: 'select',
            callback: ({ chartWrapper }) => {
                const selection = chartWrapper.getChart().getSelection();
                if (selection.length > 0) {
                    const row = selection[0].row;
                    const item = data[row];
                    if (item) onSegmentClick(item);
                }
            },
        },
    ] : [];

    return (
        <Card
            title="Tenure Distribution"
            className="chart-card"
            extra={
                onExportCSV && (
                    <Button
                        size="small"
                        variant="secondary"
                        icon={<DownloadOutlined />}
                        onClick={() => onExportCSV('tenure', data)}
                        title="Download CSV"
                    />
                )
            }
        >
            <Chart
                chartType="ColumnChart"
                data={chartData}
                options={options}
                width="100%"
                height="300px"
                chartEvents={chartEvents}
            />
        </Card>
    );
};

export default TenureDistributionChart;
